import { type FeatureFlagConfig, featureFlags } from '@/featureFlags/registry';

const isAllowedValue = (config: FeatureFlagConfig, rawValue: string) => {
  if (config.type === 'boolean') {
    return rawValue === 'true' || rawValue === 'false';
  }

  return config.variants.some(variant => variant === rawValue);
};

const parseValue = (config: FeatureFlagConfig, rawValue: string): boolean | string => {
  if (config.type === 'boolean') {
    return rawValue === 'true';
  }

  return rawValue;
};

export const parseFeatureFlagsQueryParam = (value: string | null): Record<string, boolean | string> => {
  if (!value) {
    return {};
  }

  const configsByKey = new Map<string, FeatureFlagConfig>(
    Object.values(featureFlags).map(config => [config.key, config]),
  );
  const result: Record<string, boolean | string> = {};

  for (const pair of value.split(',')) {
    const separatorIndex = pair.indexOf(':');
    if (separatorIndex <= 0) {
      continue;
    }

    const key = pair.slice(0, separatorIndex).trim();
    const rawValue = pair.slice(separatorIndex + 1).trim();
    const config = configsByKey.get(key);

    if (!config || !isAllowedValue(config, rawValue)) {
      continue;
    }

    result[key] = parseValue(config, rawValue);
  }

  return result;
};
